export function formValueEmptyFields(formValue: any): any {
  if (!formValue) {
    return;
  }

  formValue = structuredClone(formValue);

  Object.keys(formValue).forEach((control: any) => {
    if (typeof formValue[control] === 'string' && formValue[control] === '') {
      formValue[control] = undefined;
    }
  });

  return formValue;
}
